import { FC } from 'react';

interface ConfirmationModalProps {
  handleClick?: Function;
  description?: string;
  buttonText?: string;
  loading?: boolean;
  closeModal?: () => void;
}

const ConfirmationModal: FC<ConfirmationModalProps> = ({
  handleClick,
  description,
  buttonText,
  loading,
  closeModal,
}) => {
  return (
    <>
      <p className="f-s14 cz-mb-32">{description}</p>
      <div className="max-content mx-auto">
        <button
          type="button"
          className="btn btn-large position-relative  d-block mb-3 red"
          onClick={() => {
            handleClick();
          }}
          disabled={loading}
        >
          {buttonText}
        </button>
      </div>
      <div className="max-content mx-auto">
        <button
          type="button"
          className="btn btn-text position-relative  d-block mb-3 red text-transform-none"
          onClick={closeModal}
        >
          Cancel
        </button>
      </div>
    </>
  );
};

export default ConfirmationModal;
